import { __rest, __assign } from '../../../node_modules/tslib/tslib.es6.js';
import React__default__default, { forwardRef } from 'react';
import PropTypes__default from 'prop-types';
import { AutocompleteOptionPropTypes } from './autocomplete-option.js';

var AutocompleteOptionGroup = /*#__PURE__*/forwardRef(function (_a, ref) {
  var bem = _a.bem,
    groupName = _a.groupName,
    children = _a.children,
    appearance = _a.appearance,
    rest = __rest(_a, ["bem", "groupName", "children", "appearance"]);
  return /*#__PURE__*/React__default__default.createElement("ul", __assign({
    ref: ref,
    role: "group"
  }, rest, {
    className: bem.e('list', {
      boxed: appearance === 'boxed',
      flat: appearance === 'flat'
    }),
    "aria-labelledby": groupName === null || groupName === void 0 ? void 0 : groupName.props.id
  }), groupName, children);
});
var AutocompleteGroupName = /*#__PURE__*/forwardRef(function (_a, ref) {
  var bem = _a.bem,
    id = _a.id,
    children = _a.children,
    rest = __rest(_a, ["bem", "id", "children"]);
  return /*#__PURE__*/React__default__default.createElement("li", __assign({}, rest, {
    id: id,
    role: "presentation",
    className: bem.e('group-name'),
    ref: ref
  }), children);
});
var AutocompleteGroupPropTypes = PropTypes__default.shape({
  group: PropTypes__default.node.isRequired,
  key: PropTypes__default.string.isRequired,
  options: PropTypes__default.arrayOf(AutocompleteOptionPropTypes).isRequired
});

export { AutocompleteGroupName, AutocompleteGroupPropTypes, AutocompleteOptionGroup };
